import { render, staticRenderFns } from "./RefractiveDiscrepancyUser.vue?vue&type=template&id=bf016f90&scoped=true&"
import script from "./RefractiveDiscrepancyUser.vue?vue&type=script&lang=js&"
export * from "./RefractiveDiscrepancyUser.vue?vue&type=script&lang=js&"
import style0 from "./RefractiveDiscrepancyUser.vue?vue&type=style&index=0&id=bf016f90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf016f90",
  null
  
)

export default component.exports